import React, { useMemo } from 'react'
import style from '../tabs.module.scss'

export const Tab = ({activeTab, title, onClick}) => {

    const isActive = useMemo(() => activeTab === title ? style['tab-list-active'] : '', [activeTab])

    const onItemClick = () => {
        onClick(title)
    }

    return (
        <li
            className={`${style['tab-list-item']} ${isActive}`}
            onClick={onItemClick}>
            <span>{title}</span>
        </li>
    )
}
